import script from "./NumberBets.vue?vue&type=script&setup=true&lang=js"
export * from "./NumberBets.vue?vue&type=script&setup=true&lang=js"

import "./NumberBets.vue?vue&type=style&index=0&id=6e556ee2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e556ee2"]])

export default __exports__